
import React, { useState, memo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useTheme } from "@mui/material";

const LapsTable = memo(({ laps }) => {
  const [lapNames, setLapNames] = useState({});
  const theme = useTheme();

  const handleNameChange = (lapNumber, name) => {
    setLapNames({ ...lapNames, [lapNumber]: name });
  };

  const columns = [
    {
      field: "lapNumber",
      headerName: "#",
      width: 30,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      headerName: "Name It",
      width: 200,
      renderCell: (params) => (
        <input
          type="text"
          placeholder="Name this lap"
          className="input input-bordered input-xs w-full max-w-xs"
          value={lapNames[params.row.lapNumber] || ""}
          onChange={(e) => handleNameChange(params.row.lapNumber, e.target.value)}
          style={{
            padding: "4px",
            fontSize: "12px",
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "4px",
            width: "100%",
            background: theme.palette.background.paper,
            color: theme.palette.text.primary,
          }}
        />
      ),
    },
    { field: "interval", headerName: "Interval", width: 100, align: "left" },
    { field: "lapTime", headerName: "Total", width: 100, align: "left" },
    {
      field: "systemTime",
      headerName: "Recorded at",
      width: 250,
      align: "left",
    },
  ];

  const rows = laps.map((lap, index) => ({
    id: index,
    lapNumber: lap.lapNumber,
    name: lapNames[lap.lapNumber] || "",
    interval: lap.interval,
    lapTime: lap.lapTime,
    systemTime: lap.systemTime,
  }));

  return (
    <div className="mt-[24px]">
      {laps.length > 0 && (
        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            disableColumnMenu
            checkboxSelection={true}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                fontWeight: "bold",
                position: "sticky",
                top: 0,
                zIndex: 1,
              },
              "& .MuiDataGrid-row": {
                borderBottom: `1px solid ${theme.palette.divider}`,
              },
              "& .MuiDataGrid-cell": {
                fontSize: "12px",
                color: theme.palette.text.primary,
              },
              "& .MuiDataGrid-root": {
                border: `2px solid ${theme.palette.divider}`,
                borderRadius: "8px",
                backgroundColor: theme.palette.background.paper,
              },
            }}
          />
        </div>
      )}
    </div>
  );
});

export default LapsTable;
